import { render, staticRenderFns } from "./bookRelation.vue?vue&type=template&id=60bad94c&scoped=true&"
import script from "./bookRelation.vue?vue&type=script&lang=js&"
export * from "./bookRelation.vue?vue&type=script&lang=js&"
import style0 from "./bookRelation.vue?vue&type=style&index=0&id=60bad94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bad94c",
  null
  
)

export default component.exports